var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 32,
    viewBox: "0 0 147 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98238 4.17956C4.12766 3.1989 4.96942 2.47266 5.96079 2.47266H140.156C141.147 2.47266 141.989 3.1989 142.134 4.17956L145.777 28.7675C145.956 29.9756 145.019 31.0606 143.798 31.0606H2.31813C1.09686 31.0606 0.160742 29.9756 0.339718 28.7675L3.98238 4.17956Z",
    fill: "#313248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98238 2.06237C4.12766 1.08171 4.96942 0.355469 5.96079 0.355469H140.156C141.147 0.355469 141.989 1.08171 142.134 2.06237L145.777 26.6503C145.956 27.8584 145.019 28.9434 143.798 28.9434H2.31813C1.09686 28.9434 0.160742 27.8584 0.339718 26.6503L3.98238 2.06237Z",
    fill: "#3E4054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M102.175 26.8253L99.5283 3.00195H101.117L103.764 26.8253H102.175Z",
    fill: "#2B2D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.352 10.9434L124.94 11.4728L125.612 16.5021H134.999L135.527 18.0903H124.267L123.352 10.9434Z",
    fill: "#2B2D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardStandard);
export default __webpack_public_path__ + "static/media/KeyboardStandard.15ff804cc1e272a9beed2896dd6dc278.svg";
export { ForwardRef as ReactComponent };